(function() {

	var ShoppingCartPage = function(sendCheckoutWebhookURL, loadShipping) {
		var self = this;
		this.sendCheckoutWebhookURL = sendCheckoutWebhookURL;

		$('input.quantity-input').change(function() {
			self.validateQuantity(this, true);
		});
		$('input.quantity-input').each(function(i, elem) {
			self.validateQuantity(elem, false);
		});
		
		this.validator = new C.FormValidator('form#newShoppingListForm');
		
		$('form#newShoppingListForm').on('submit', function(event) {
			if(!self.validator.isValid()) {
				event.preventDefault();
			}
		});

		if (loadShipping) {
			this.sendCheckoutWebhook()
		}

		this.initRestoreButton();
	};

	ShoppingCartPage.prototype = {

		showErrorDialog: function() {
			$('#errorDialog').modal();
			return false;
		},

		updateQuantity: function(id) {
			$('#updateQuantityForm' + id).submit();
		},
		
		removeItem: function(id) {
			$('#deleteItemForm' + id).submit();
		},

		initRestoreButton: function() {
			$('#restore-last-cart').on('click', function(e) {
				if ($('tr.item').length > 1) {
					e.preventDefault();
					$('#confirmation-modal .modal-body').html('This will replace the current items in your cart. Are you sure?')
					$('#confirmation-modal').modal()
					$('#confirm-button').on('click', function () {
						console.log('real submit')
						$('#restore-cart-form').submit();
					})
				}
			})
			$('#confirmation-modal').on('hide.bs.modal', function() {
				$('#confirm-button').unbind('click')
			})
		},
		
		showShoppingListDialog: function() {
			// Reset the errors
			$('#shopping_list_dialog div.form-group').removeClass('has-error');
			$('#shopping_list_dialog div.tooltip').remove();
			$('#shopping_list_dialog input').removeAttr('data-original-title');
			
			$('#shopping_list_dialog').modal();
		},
		
		submitNewShoppingListForm: function() {
			$('#newShoppingListForm').submit();
		},
		
		prepareAddListToCartForm: function() {
			$(".shopping-cart-items .item-checkbox:checkbox:checked").each(function(i) {
				// Skip children
				if (!$(this).hasClass('child-checkbox')) {
					// create id/quantity inputs for each selected item
					$("#addListToCart").append("<input type='hidden' name='products["+i+"][product_id]' value='"+$(this).data('id')+"'>");
					$("#addListToCart").append("<input type='hidden' name='products["+i+"][quantity]' value='"+$(this).data('quantity')+"'>");
					if ($(this).data('customizations')) {
						$("#addListToCart").append("<input type='hidden' name='products["+i+"][product_customizations]' value='"+JSON.stringify($(this).data('customizations'))+"'>")
					}
				}
				if ($(this).hasClass("parent")) {
					// Create inputs for each of the children
					var parent_id = $(this).data('sc-item-id');
					 $(".shopping-cart-items .item-checkbox[data-parent='"+parent_id+"']").each(function() {
						 $("#addListToCart").append("<input type='hidden' name='products["+i+"][children]["+$(this).data('id')+"]' value='"+$(this).data('quantity')+"'>");
					 })
				}
			});
		},
		
		validateSelectedItems: function(has_cart_errors, cart_errors) {
			// If no items are selected when Add To Cart is clicked, display an error
			if ($(".shopping-cart-items .item-checkbox:checkbox:checked").length === 0) {
				$('#noItemsSelectedDialog').modal();
				return false;
			}
			
			// If the cart has errors, don't allow invalid items to be added to cart.
			// Allow items without errors to be added
			selected_items_have_errors = false
			if (has_cart_errors) {
				$(".shopping-cart-items .item-checkbox:checkbox:checked").each(function(i) {
					if ($(this).data('sc-item-id') in cart_errors) {
						selected_items_have_errors = true;
					}
				});
				if (selected_items_have_errors) {
					this.showErrorDialog();
					return false;
				}
			}
			this.prepareAddListToCartForm();
		},
		
		toggleCheckboxes: function() {
			var toggle = $('#checkbox-toggle').prop("checked");

			boxes = $('.item-checkbox');
			boxes.each(function (index) {
				$(this).prop("checked", toggle);
			});
		},
		
		toggleSelectAll: function(element) {
			// Toggle children checkboxes based on parent
			if ($(element).hasClass('parent')) {
				var parent_id = $(element).data('sc-item-id');
				var checked = $(element).is(':checked');
				$('.item-checkbox[data-parent="'+parent_id+'"]').prop("checked", checked);
			}
			
			var toggle = ($('.item-checkbox:checked').length == $('.item-checkbox').length);
			$('#checkbox-toggle').prop("checked", toggle);
		},
		
		toggleEditNameForm: function() {
			$("#list-header").toggle();
			$("#edit-list-name").toggle();
		},
		
		submitEditNameForm: function() {
			$("#edit-list-name-form").submit();
		},
		
		validateQuantity: function(elem, show) {
			
			var input = $(elem),
				quantity = input.val(),
				minQuantity = input.data('min-quantity'),
				maxQuantity = input.data('max-quantity'),
				orderInterval = input.data('order-interval');

			var msg = this._quantityError(quantity, minQuantity, maxQuantity, orderInterval);
			var prevMsg = input.data('error');
			input.data('error', msg);
			
			var tooltipExists = !!input.data('bs.tooltip');

			if(msg) {
				input.parent().addClass('has-error');
				if(!tooltipExists) {
					// Create the tooltip
					input.tooltip({ title: msg }).tooltip(show ? 'show' : 'hide');
				}
				else if(msg != prevMsg) {
					// The error message has changed - update the tooltip
					input.attr('data-original-title', msg)
						.tooltip('fixTitle')
						.tooltip(show ? 'show' : 'hide');
				}
			}
			else if(tooltipExists) {
				input.parent().removeClass('has-error');
				input.tooltip('destroy');
			}
		},

		showErrorItem: function(itemID) {
			$('#item-' + itemID + ' .quantity-input').focus();
		},
		
		_quantityError: function(q, minQuantity, maxQuantity, orderInterval) {
			var prefix = "Quantity cannot be ";
			if(q === "") {
				return prefix + "blank";
			}
			q = parseFloat(q.replace(/,/, ''));
			var err = null;
			if(isNaN(q)) {
				err = "Quantity must be a number";
			}
			else if(q === 0) {
				err = prefix + "0";
			}
			else if(q < 0) {
				err = prefix + "less than 0";
			}
			else if(minQuantity && q < parseFloat(minQuantity)) {
				err = "Quantity must be greater than or equal to " + minQuantity;
			}
			else if(maxQuantity && q > parseFloat(maxQuantity)) {
				err = "Quantity must be less than or equal to " + maxQuantity;
			}
			else if(orderInterval && AccurateMath.mod(q, parseFloat(orderInterval)) !== 0) {
				err = "Quantity is not a multiple of " + orderInterval;
			}
			return err;
		},

		sendCheckoutWebhook: function() {
			$.ajax(this.sendCheckoutWebhookURL, {
				method: 'get',
				success: function(json) {
					console.log('success')
					console.log(json)

					if (json.reload_page_for_shipping) {
						let currentURL = window.location.href
						let shippingLoadedParam = "shippingLoaded=1";
						let newURL = currentURL.includes("?") ? `${currentURL}&${shippingLoadedParam}` : `${currentURL}?${shippingLoadedParam}`;
						window.location.href = newURL;
					}

					if (json.tax_amount) {
						$('#cart-tax-display').html(C.renderMoney(json.tax_amount))
					} else {
						$('#cart-tax-wrapper').hide()
					}

					if (json.shipping_amount) {
						$('#cart-shipping-display').html(C.renderMoney(json.shipping_amount))
					} else {
						$('#cart-shipping-wrapper').hide()
					}

					$('#cart-total-display').html(C.renderMoney(json.total))
					$('#amounts-loading-overlay').hide()
					$('#loading-amounts').prop('id', '')
				},
				error: function(e) {
					console.log('error')
					console.log(e)
				}
			})
		}
		
	};

	C.ShoppingCartPage = ShoppingCartPage;
	
})();